module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 suggestions.forEach( suggestion => { 
__p+='\n<a href="/shop-suche/?'+
((__t=( new URLSearchParams( {
	query: suggestion.name,
	fromSearchtermSuggest: 'true',
} ).toString() ))==null?'':__t)+
'" class="mdl_search__suggestions-searchterm">'+
((__t=( suggestion.name ))==null?'':__t)+
'</a>\n';
 } ) 
__p+='\n';
}
return __p;
};
